import "../../functions";

import React, { setGlobal, useEffect, useState } from "reactn";

import API from "../../api";
import Button from "../../components/Button";
import Confirm from "../../components/Confirm";
import Container from "../../components/Container";
import Form from "../../components/Form";
import Modal from "../../components/Modal";
import Status from "../../components/Status";
import Table from "../../components/Table";
import { withRouter } from "react-router-dom";

const User = ({
	match: {
		params: { id },
	},
	history,
	canEdit,
	canDelete,
}) => {
	useEffect(function () {
		(function () {
			setGlobal({ title: "User" });
		})();
	}, []);

	const [editMode, setEditMode] = useState(false);
	const [user, setUser] = useState(null);
	const [error, setError] = useState(null);
	const [resetPasswordStage, setResetPasswordStage] = useState(0);
	const [newPassword, setNewPassword] = useState("");
	const [copied, setCopied] = useState(false);

	useEffect(function () {
		(async function () {
			const { success, error, info } = await API.users.findOne(id);

			if (success) setUser(info);
			else setError(error);
		})();
	}, []);

	const setField = (key, value) => {
		const fields = { ...user };
		fields[key] = value;
		setUser(fields);
	};

	const handleSubmit = async () => {
		const { success, error } = await API.users.updateOne(id, user);

		if (success) history.push("/users");
		else setError(error);
	};

	const handleDelete = async () => {
		const { success, error } = await API.users.deleteOne(id);

		if (success) history.push("/users");
		else setError(error);
	};

	const handleResetPassword = async () => {
		const { success, error, password } = await API.users.resetPassword(id);

		if (success) {
			setNewPassword(password);
			setResetPasswordStage(2);
		} else {
			setError(error);
			setResetPasswordStage(0);
		}
	};

	const handleCopyPassword = () => {
		navigator.clipboard.writeText(newPassword);
		setCopied(true);
		setTimeout(() => {
			setResetPasswordStage(0);
			setCopied(false);
		}, 1000);
	};

	return (
		<Container>
			<Status error>{error}</Status>
			{user ? (
				<>
					{canEdit && (
						<p
							className="text-primary"
							style={{ textAlign: "center" }}
							onClick={() => setEditMode(!editMode)}
						>
							<a>Switch to {editMode ? "review" : "edit"} mode</a>
						</p>
					)}
					{editMode ? (
						<Form onSubmit={() => handleSubmit()}>
							{Object.keys(user).map((key, index) => (
								<Form.Group key={index}>
									<Form.Label>{key.capitalize()}</Form.Label>
									<Form.Input
										key={index}
										value={
											user[key] !== null
												? user[key].toString()
												: ""
										}
										onChange={({ value }) =>
											setField(key, value)
										}
									/>
								</Form.Group>
							))}
							<Form.Group>
								<Form.Label>Password</Form.Label>
								<Button
									type="button"
									onClick={setResetPasswordStage.bind(
										null,
										1,
									)}
								>
									Reset Password
								</Button>

								{resetPasswordStage === 1 && (
									<Modal
										show={resetPasswordStage === 1}
										title="Reset Password"
										onClose={() => setResetPasswordStage(0)}
									>
										<Modal.Body>
											Are you sure you want to reset this
											user's password?
											<br />
											Click <i>OK</i> to confirm.
										</Modal.Body>
										<Modal.ButtonGroup>
											<Button
												variant="secondary"
												type="button"
												onClick={() =>
													setResetPasswordStage(0)
												}
												style={{ marginRight: "10px" }}
											>
												Cancel
											</Button>
											<Button
												variant="danger"
												type="button"
												onClick={handleResetPassword}
											>
												OK
											</Button>
										</Modal.ButtonGroup>
									</Modal>
								)}

								<Modal
									show={resetPasswordStage === 2}
									title="Reset Password"
									onClose={() => {
										setResetPasswordStage(0);
										setCopied(false);
									}}
								>
									<Form.Group>
										<Form.Label>New Password</Form.Label>
										<Form.Input
											readOnly
											value={newPassword}
										/>
									</Form.Group>
									<Button
										type="button"
										variant="primary"
										onClick={handleCopyPassword}
										disabled={copied}
									>
										{copied ? "Copied" : "Copy"}
									</Button>
								</Modal>
							</Form.Group>
							<Button
								type="submit"
								variant="primary"
								style={{ marginTop: "2rem" }}
							>
								Save Changes
							</Button>
						</Form>
					) : (
						<Table>
							<tbody>
								{Object.keys(user).map((key, index) => (
									<tr key={index}>
										<th>{key.capitalize()}</th>
										<td>{user[key]}</td>
									</tr>
								))}
							</tbody>
						</Table>
					)}
				</>
			) : (
				<Status.Switch data={user} />
			)}
			{canDelete && (
				<Confirm onConfirm={() => handleDelete()}>Delete user</Confirm>
			)}
		</Container>
	);
};

export default withRouter(User);
